import React, { Component } from "react";

import {
  Wrapper,
  CardBody,
  Title,
  Copy,
  Bold,
  Row,
  Icon,
  Button,
  Spin
} from "app/NativeComponents/common";

import ConversationItemImage from "./ConversationItemImage";

import { renderDate, determineMainOwnerInfo } from "app/NativeActions";

class ConversationItem extends Component {
  renderTitle(item) {
    if (item) {
      if (item.property) {
        const owner_info = determineMainOwnerInfo(item.property);
        return (
          <Wrapper>
            <Copy>
              <Bold>{owner_info.owner_name}</Bold>
            </Copy>
            <Copy>
              {item.lead_phone_number
                ? item.lead_phone_number.phone_number
                : ""}
            </Copy>
          </Wrapper>
        );
      }

      return (
        <Copy>
          <Bold>
            {item.lead_phone_number ? item.lead_phone_number.phone_number : ""}
          </Bold>
        </Copy>
      );
    }
  }

  renderMessageTime(item) {
    if (item && item.last_message_date) {
      if (item.unread_messages) {
        return (
          <Wrapper>
            <Row>
              <Wrapper
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 5,
                  marginRight: 5,
                  backgroundColor: this.props.colors.active_color
                }}
              />
              <Copy
                style={{ fontSize: 12, color: this.props.colors.active_color }}
              >
                {renderDate(item.last_message_date, false, "from_now")}
              </Copy>
            </Row>
          </Wrapper>
        );
      }
      return (
        <Wrapper>
          <Copy
            style={{ fontSize: 12, color: this.props.colors.light_text_color }}
          >
            {renderDate(item.last_message_date, false, "from_now")}
          </Copy>
        </Wrapper>
      );
    }
  }

  checkIfInActiveConversation(item, active_conversation) {
    if (active_conversation && active_conversation.length > 0) {
      for (let i = 0; i < active_conversation.length; i++) {
        if (active_conversation[i].id == item.id) {
          return true;
        }
      }
    }

    return false;
  }

  renderHoverButton(conversation) {
    if (this.props.device == "desktop" && !this.props.isMobile) {
      if (
        this.props.update_conversation_loading.some(
          conversation_id => conversation_id === conversation.id
        )
      ) {
        return (
          <Wrapper
            style={{
              position: "absolute",
              right: 0,
              width: "100%",
              left: 0,
              top: 0,
              bottom: 0,
              backgroundColor:
                this.props.dark_mode == "dark_mode"
                  ? "rgba(31,41,51, 0.25)"
                  : "rgba(255, 255, 255, 0.75)",
              height: "100%",
              alignItems: "flex-end",
              justifyContent: "center"
            }}
          >
            <Wrapper
              style={{
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Row>
                <Spin size="small" />
                <Copy style={{ marginLeft: 5 }}>
                  {conversation.closed_conversation == 1
                    ? "Reopening Conversation..."
                    : "Closing Conversation..."}
                </Copy>
              </Row>
            </Wrapper>
          </Wrapper>
        );
      } else if (conversation.closed_conversation != 1) {
        return (
          <Wrapper
            className="deal-preview"
            style={{
              position: "absolute",
              right: 0,
              width: 70,

              height: "100%",
              alignItems: "flex-end",
              justifyContent: "center"
            }}
          >
            <Button
              style={{
                width: 50,
                height: 50,
                borderRadius: 25,
                margin: 10,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor:
                  this.props.dark_mode == "dark_mode"
                    ? "rgba(31,41,51, 0.25)"
                    : "rgba(255, 255, 255, 0.75)"
              }}
              onPress={() => {
                this.props.updateConversation({
                  token: this.props.token,
                  type: "quick_close_conversation",
                  conversation_id: conversation.id,
                  onSuccess: () => {}
                });
              }}
              tooltip={"Close Conversation"}
              tooltipPlacement={"bottom"}
            >
              <Icon icon={"speaker-notes-off"} size={18} />
            </Button>
          </Wrapper>
        );
      } else if (conversation.closed_conversation == 1) {
        return (
          <Wrapper
            className="deal-preview"
            style={{
              position: "absolute",
              right: 0,
              width: 70,

              height: "100%",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Button
              style={{
                width: 50,
                height: 50,
                borderRadius: 25,
                margin: 10,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor:
                  this.props.dark_mode == "dark_mode"
                    ? "rgba(31,41,51, 0.25)"
                    : "rgba(255, 255, 255, 0.75)"
              }}
              tooltip={"Reopen Conversation"}
              tooltipPlacement={"bottom"}
              onPress={() => {
                this.props.updateConversation({
                  token: this.props.token,
                  type: "quick_open_conversation",
                  conversation_id: conversation.id,
                  onSuccess: () => {}
                });
              }}
            >
              <Icon icon={"sms"} size={18} />
            </Button>
          </Wrapper>
        );
      }
    }
  }

  render() {
    const { active_conversation, item, colors, isMobile, onPress } = this.props;
    if (item) {
      return (
        <Wrapper
          style={{
            position: "relative"
          }}
          className="deal-hover-preview"
        >
          <Button onPress={onPress}>
            <CardBody
              style={{
                borderBottomWidth: 1,
                borderBottomColor: colors.border_color,
                borderBottomStyle: "solid",
                backgroundColor: this.checkIfInActiveConversation(
                  item,
                  active_conversation
                )
                  ? colors.background_color
                  : colors.card_color,
                padding: 15
              }}
            >
              <Row>
                <ConversationItemImage item={item} colors={colors} />
                <Wrapper style={{ flex: 1 }}>{this.renderTitle(item)}</Wrapper>
                {this.renderMessageTime(item)}
              </Row>

              <Wrapper style={{ marginTop: 10 }}>
                <Copy style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                  {item.last_message_text}
                </Copy>
              </Wrapper>
            </CardBody>
          </Button>
          {this.renderHoverButton(item)}
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default ConversationItem;
